import classNames from "classnames";

import HelpLink from "./help-link";

export default function HelpFooterShell({
  children,
  footerClassName,
}: {
  children: React.ReactNode;
  footerClassName?: string;
}) {
  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        {children}
      </div>
      <footer
        className={classNames(
          "shrink-0 flex justify-end px-2 py-[4px]",
          footerClassName,
        )}
      >
        <HelpLink />
      </footer>
    </div>
  );
}
